import { render } from "./Subscriptions.vue?vue&type=template&id=05a0e4cc"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__